import React from "react";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/lib/site";

export const ContactSuccess = ({ onReset }) => (
  <div data-testid="contact-form-success" className="flex flex-col items-start gap-4 py-6">
    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#eef7f7]">
      <CheckCircle2 className="h-6 w-6 text-[#0f6e73]" aria-hidden="true" />
    </span>
    <div>
      <h3 className="font-display text-xl font-semibold text-[#0b1d3a]">
        Thank you — your enquiry is with us
      </h3>
      <p className="mt-2 max-w-prose text-sm leading-relaxed text-slate-600">
        A member of the Moruya head office team will review your message and reply by email.
        If it is urgent, message us on WhatsApp and we will pick it up faster.
      </p>
    </div>
    <div className="flex flex-col gap-3 sm:flex-row">
      <Button
        asChild
        className="bg-[#148a8f] text-white transition-colors hover:bg-[#0f6e73]"
        data-testid="success-whatsapp-button"
      >
        <a href={COMPANY.whatsappLink} target="_blank" rel="noopener noreferrer">
          <MessageCircle className="mr-2 h-4 w-4" /> Message on WhatsApp
        </a>
      </Button>
      <Button
        variant="outline"
        onClick={onReset}
        data-testid="contact-form-reset-button"
        className="border-slate-300 text-[#0b1d3a]"
      >
        Send another enquiry
      </Button>
    </div>
  </div>
);
